import { styled, Text, TextAlignment, TokenTextAppearance, TextTag } from "@volkswagen-onehub/components-core";
import React from "react";

type Props = React.PropsWithChildren<{
  header?: string;
  subhead?: string | JSX.Element;
}>;

const StyledContainer = styled.div`
  height: 80vh;
  padding: 16px;
  display: grid;
  grid-auto-flow: row;
  grid-row-gap: 16px;
  justify-items: center;
  align-content: center;
`;

export const Sorry = ({
  header,
  subhead,
  children
}: Props) => {
 return (
  <StyledContainer>
    {
      header
      ? <Text tag={TextTag.h2} appearance={TokenTextAppearance.headline600} bold textAlign={TextAlignment.center}>
        { header }
      </Text>
      : null
    }
    {
      subhead
      ? <Text tag={TextTag.p} textAlign={TextAlignment.center}>
        { subhead }
      </Text>
      : null
    }
    { children }
  </StyledContainer>
 );
};
